<template>
    <div class="border bg-white dark:bg-gray-700 text-black dark:text-white rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3">
        <div
            class="flex justify-between items-center cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-600 p-4"
            @click="collapsed = !collapsed"
        >
            <div>
                ATF Tiles ({{ atf_tile.use_atf_tiles == 1 ? "active" : "inactive" }})
            </div>
            <div>
                <svg v-if="!collapsed" class="h-4 w-4 cursor-pointer" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
                <svg v-if="collapsed" class="h-4 w-4 cursor-pointer" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
                </svg>
            </div>
        </div>
        <div v-if="collapsed">
            <Select
                label="Use ATF Tiles"
                name="use_atf_tiles"
                v-model="atf_tile.use_atf_tiles"
                :options="[
                    { value: 1, name: 'Yes' },
                    { value: 0, name: 'No' },
                ]"
                :error="errors['atf_tile.use_atf_tiles'] ? errors['atf_tile.use_atf_tiles'][0] : null"
            />
            <input-text
                label="Heading"
                name="heading"
                v-model="atf_tile.heading"
                class="mt-3"
                :maxlength="255"
                :error="errors['atf_tile.heading'] ? errors['atf_tile.heading'][0] : null"
            />
            <p class="text-xs text-gray-600 dark:text-gray-200">
                You can use these available shortcodes in the heading field
                above: [current_year], [current_month] and [current_abrev_month]
            </p>

        <atf-tile-items
            class="mt-3"
            v-model="atf_tile.items"
            :language="language"
            :document-type="documentType"
            :tiles-count="tilesCount"
            :errors="errors"
        />

        </div>
    </div>
</template>

<script>

export default {
    name: "AtfTile",
    props: {
        value: {
            type: Object,
            required: true
        },
        documentType: {
            type: String,
            required: true
        },
        tilesCount: {
            type: Number,
            required: true
        },
        errors: {
            type: [Array, Object],
            required: true,
        },
        language: {
            type: Object,
            default: () => {
                return { iso: siteLanguage.iso.ENGLISH };
            }
        }
    },
    data() {
        return {
            atf_tile: this.value,
            collapsed: 0
        };
    }
};
</script>
